export const BUZZ_SOURCE_ICONS = {
  google: 'i-logos-google-icon',
  facebook: 'i-logos-facebook',
  instagram: 'i-woot-instagram',
  twitter: 'i-ri-twitter-x-fill',
  tiktok: 'i-woot-tiktok',
  linkedin: 'i-ri-linkedin-box-fill',
};

export const resolveSourceIcon = source => {
  const key = (source || 'google').toLowerCase();
  return BUZZ_SOURCE_ICONS[key] || 'i-ri-global-line';
};

export const mentionHost = (domain, link) => {
  if (domain && domain !== '—') return domain.replace(/^www\./i, '');
  if (!link) return '';
  try {
    return new URL(link).hostname.replace(/^www\./i, '');
  } catch {
    return '';
  }
};

export const mentionFaviconUrl = (domain, link) => {
  const host = mentionHost(domain, link);
  if (!host) return null;
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=32`;
};
